import classNames from 'classnames';
import IconButton from 'components/Buttons/IconButton';
import { SELECTORES_CSS } from 'constants/albert_events';
import React from 'react';

const EmisionFooterBarButtons = ({
  onClickGuardar,
  showAtras = true,
  onClickAtras,
  onClickContinuar,
  showGuardar = true,
  btnContinuarClassName = '',
  btnGuardarClassName = '',
  btnAtrasClassName = '',
  labelAtras = 'ATRÁS',
  labelGuardar = 'GUARDAR',
  labelContinuar = 'CONTINUAR',
}) => {
  return (
    <React.Fragment>
      <span className="p-buttonset" style={{ width: '100%' }}>
        <div className="row justify-content-center">
          <div className="col-12 col-md-9 my-auto bg-white">
            <h6 className="ml-2 py-2" style={{ fontSize: '20px' }}>
              Recuerda que al dar click en guardar, tu información quedará almacenada y podrás
              cerrar la ventana en cualquier momento para continuar después.
            </h6>
          </div>
        </div>
        <div className="row justify-content-center">
          {showAtras && (
            <div className="col-12 col-md-3 my-auto bg-white py-2">
              <IconButton onClick={onClickAtras} className={btnAtrasClassName}>
                <i
                  className="pi pi-arrow-left"
                  style={{ position: 'relative', top: '1px', fontSize: '1.25rem' }}
                />{' '}
                {labelAtras}
              </IconButton>
            </div>
          )}

          {showGuardar && (
            <div className="col-12 col-md-3 my-auto bg-white py-2">
              <IconButton onClick={onClickGuardar} className={btnGuardarClassName}>
                <i
                  className="pi pi-save"
                  style={{ position: 'relative', top: '2px', fontSize: '1.25rem' }}
                />{' '}
                {labelGuardar}
              </IconButton>
            </div>
          )}

          <div className="col-12 col-md-3 my-auto py-2">
            <IconButton
              variant="primary"
              onClick={onClickContinuar}
              className={classNames(SELECTORES_CSS.GENERAL.btnContinuar, btnContinuarClassName)}
            >
              {labelContinuar}{' '}
              <i
                className="pi pi-arrow-right"
                style={{ position: 'relative', top: '1px', fontSize: '1.25rem' }}
              />
            </IconButton>
          </div>
        </div>
      </span>
    </React.Fragment>
  );
};

export default EmisionFooterBarButtons;
